import { Injectable, Injector, inject } from '@angular/core'

import { HarnessWriteTarget } from '@flowx/designer/modules/ai-builder/types/conversation.types'
import { FlxNavigationService } from '@flowx/designer/shared/services/navigation.service'

/**
 * Opens a conversation's write target in the designer: a route change, the same one the branch
 * chip makes, so the whole designer moves rather than the conversation alone.
 *
 * Resolved lazily rather than injected up front: `FlxNavigationService` reaches into the ngrx store
 * and `APP_BASE_HREF`, and the session store is root-provided and instantiated by every surface of
 * the builder — a hard dependency would put the whole routing world under each of them.
 */
@Injectable({ providedIn: 'root' })
export class HarnessWriteTargetNavigator {
  readonly #injector = inject(Injector)

  /** Open a conversation's write target on its head, which may be in another workspace or project
   * than the one currently on screen. */
  openWriteTarget(target: HarnessWriteTarget): Promise<boolean> {
    return this.#injector
      .get(FlxNavigationService)
      .navigateToApplicationVersionIn(target.workspace_id, target.app_id, target.head_version_id)
  }
}
